import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
    iconPack: 'fontawesome',
    duration: 5000
});

Vue.toasted.register(
    'success',
    payload => {
        // if there is no message passed show default message
        if (!payload.message) {
            return 'Operation completed successfully.';
        }

        // if there is a message show it with the message
        return payload.message;
    },
    {
        type: 'success',
        icon: 'check-square'
    }
);

Vue.toasted.register(
    'error',
    payload => {
        // if there is no message passed show default message
        if (!payload.message) {
            return 'Oops.. Something Went Wrong..';
        }

        // if there is a message show it with the message
        return payload.message;
    },
    {
        type: 'error',
        icon: 'exclamation-circle'
    }
);

window.flash = {
    success: Vue.toasted.global.success,
    error: Vue.toasted.global.error
};
